(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
